import 'select2';
import utils from './lsag.utils';

// DEMO

const select2 = {
    selectMenu: $('.js-select2'),
    build() {
        this.selectMenu.select2({
            width: '100%',
            minimumResultsForSearch: Infinity
        });
    },
    bindEvents() {
        this.selectMenu.on('select2:select', function (evt) {
            utils.logger.log(evt);
        });
    }
};

// DOM ready
$(() => {
    select2.build();
    select2.bindEvents();
});

export default select2;
